import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import DewPointIcon from '@/comp/common/icons/DewPointIcon';
import PressureComboIcon from '@/comp/common/icons/PressureComboIcon';
import { MetricType } from '@/constants/metric-type.enum';
import UnitsEnum from '@/constants/unitsEnum';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { DewpointAndPressureSensorNodeModel } from './DewpointAndPressureSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';

export class DewpointAndPressureSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.DewpointAndPressureSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new DewpointAndPressureSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={83}
        height={44}
        data={[
          {
            metric: MetricType.DewpointTemperatureCelsius,
            unit: UnitsEnum.celsius,
            Icon: <DewPointIcon />,
          },
          {
            metric: MetricType.PressureBar,
            unit: UnitsEnum.bar,
            Icon: <PressureComboIcon />,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
